import React from "react";
import { FaFacebookF, FaInstagram, FaWhatsapp } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-main container">
        <div className="footer-col footer-left" data-aos="fade-up">
          <h3 className="company-name">Codeonet Technologies</h3>
          <p className="footer-add-phone">
            115, SaiRam Plaza, A.B Road, Mangal Nagar Indore, M.P. , 452001
          </p>
          <p className="footer-add-phone">📞 0731-3570575</p>
          <div className="socials-icons">
            <a href="#">
              <FaFacebookF />
            </a>
            <a href="#">
              <FaInstagram />
            </a>
            <a href="#">
              <FaWhatsapp />
            </a>
            <a href="#">
              <i className="fab fa-linkedin-in"></i>
            </a>
          </div>
        </div>
        <div className="footer-col" data-aos="fade-up">
          <h4>About Us</h4>
          <ul>
            <li>
              <a href="#">Our Story</a>
            </li>
            <li>
              <a href="#">Our Team</a>
            </li>
            <li>
              <a href="#">Clients</a>
            </li>
            <li>
              <a href="#">Testinomials</a>
            </li>
            <li>
              <a href="#">Careers</a>
            </li>
          </ul>
        </div>
        <div className="footer-col" data-aos="fade-up">
          <h4>Contact</h4>
          <ul>
            <li>
              <a href="#">Help Center</a>
            </li>
            <li>
              <a href="#">Support</a>
            </li>
            <li>
              <a href="#">Locations</a>
            </li>
            <li>
              <a href="#">Call</a>
            </li>
            <li>
              <a href="#">Map</a>
            </li>
          </ul>
        </div>
        <div className="footer-col" data-aos="fade-up">
          <h4>Services</h4>
          <ul>
            <li>
              <a href="#">Consulting</a>
            </li>
            <li>
              <a href="#">Development</a>
            </li>
            <li>
              <a href="#">Design</a>
            </li>
          </ul>
          <h4 className="subscribe-title" data-aos="fade-up">
            Subscribe
          </h4>
          <div className="subscribe-form" data-aos="fade-up">
            <input type="email" placeholder="Your email" />
            <button type="submit">Subscribe</button>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2025 Codeonet Technologies. All rights reserved.</p>
        <p>
          Designed by <span>Codeonet Technology</span>
        </p>
      </div>
    </footer>
  );
}
